<template>
      <span :color="chipColor(params.value)[0]">{{ chipColor(params.value)[1] }}</span>
</template>

<script>
export default {
  name: 'CellRendererTypes',
  computed: {
    chipColor () {
      return (value) => {
        if (value === 1) return ['green', 'Şəhər']
        else if (value === 2)  return ['#333', 'Qəsəbə']
        else return ['primary', 'unknown']
      }
    }
  }
}
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
